module.exports = __webpack_public_path__ + "static/media/auth-background.5b34dae0.png";